import { LoaderFunctionArgs } from 'react-router-dom'
import { getAllPushMessage, getPushSettings } from '../../action/push'

export const pushMessagesLoader = async (args: LoaderFunctionArgs) => {
    await getAllPushMessage()

    await getPushSettings()
}
